import { render, staticRenderFns } from "./ReviewLayer.vue?vue&type=template&id=253e3eb6&scoped=true&"
import script from "./ReviewLayer.vue?vue&type=script&lang=js&"
export * from "./ReviewLayer.vue?vue&type=script&lang=js&"
import style0 from "./ReviewLayer.vue?vue&type=style&index=0&id=253e3eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e3eb6",
  null
  
)

export default component.exports